import action from '../../../abstract/action.js';
import PopupProvider from '../../../../../providers/PopupProvider';

export default action({
  label: 'Podgląd',
  icon: 'FileIcon',
  main: () => true,
  handle: function({ item }) {
    PopupProvider.setIsActive(true);
    PopupProvider.setContent({
      title: item.mail_title || '',
      content: item.mail_content || '',
      mailOriginal: item.mail_original || '',
      files: item.uploaded_files || [],
      type: item.mail_type || '',
    });
  }
});